<app-title-section></app-title-section>

<div class="card p-1 gs-dashboard-page">
  <app-logiciel-caisse-pos-filters
    #filters
    [showDateFilter]="true"
    [showWarehouseFilter]="false"
    dateFilterStorageKey="vente-dashboard"
    searchPlaceholder=""
    (filtersChange)="onFiltersChange($event)"
  ></app-logiciel-caisse-pos-filters>

  <div *ngIf="!stationId" class="card-body">
    <div class="alert alert-warning mb-0">
      Aucune station active. Sélectionnez une station depuis le hub pour afficher les indicateurs vente.
    </div>
  </div>

  <div *ngIf="loading" class="card-body gs-dashboard-loading" aria-busy="true" aria-live="polite">
    <div class="gs-dashboard-skeleton">
      <div class="gs-dashboard-skeleton__kpis">
        <span *ngFor="let _ of [1,2,3,4,5,6,7]" class="gs-dashboard-skeleton__kpi"></span>
      </div>
      <div class="gs-dashboard-skeleton__charts">
        <span *ngFor="let _ of [1,2]" class="gs-dashboard-skeleton__chart"></span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!loading && stationId && (erp || facturesGlobales)">
    <div class="card-body gs-dashboard-meta">
      <small class="text-muted">
        Période :
        {{ (erp?.filters?.date_from || dateFrom) | date:'dd/MM/yyyy' }} →
        {{ (erp?.filters?.date_to || dateTo) | date:'dd/MM/yyyy' }}
      </small>
    </div>

    <div class="card-body pb-0" *ngIf="erp">
      <p class="gs-section-title mb-0">Documents vente (ERP)</p>
    </div>
    <div class="card-body row gs-dashboard-kpis" *ngIf="erp">
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-primary">
          <div class="card-body">
            <h6>Devis</h6>
            <h3>{{ erp.kpis.devis.period | number:'1.0-0' }}</h3>
            <small>{{ erp.kpis.devis.pending }} en cours (tous)</small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-success">
          <div class="card-body">
            <h6>Commandes client</h6>
            <h3>{{ erp.kpis.commande_client.period | number:'1.0-0' }}</h3>
            <small>{{ erp.kpis.commande_client.pending }} en cours</small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-warning">
          <div class="card-body">
            <h6>Bons de livraison</h6>
            <h3>{{ erp.kpis.bon_livraison.period | number:'1.0-0' }}</h3>
            <small>{{ erp.kpis.bon_livraison.pending }} en cours</small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-danger">
          <div class="card-body">
            <h6>Factures</h6>
            <h3>{{ erp.kpis.facture.period | number:'1.0-0' }}</h3>
            <small>
              {{ erp.kpis.facture.pending_non_payee }} non payées ·
              {{ erp.kpis.facture.pending_brouillon }} brouillon
            </small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-info">
          <div class="card-body">
            <h6>Bons de sortie</h6>
            <h3>{{ erp.kpis.bon_sortie.period | number:'1.0-0' }}</h3>
            <small>{{ erp.kpis.bon_sortie.pending }} à traiter</small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card bg-light-secondary">
          <div class="card-body">
            <h6>Avoirs</h6>
            <h3>{{ erp.kpis.avoir.period | number:'1.0-0' }}</h3>
            <small>{{ erp.kpis.avoir.pending }} non / partiellement utilisés</small>
          </div>
        </div>
      </div>
      <div class="col-xl-2 col-md-4 col-sm-6 mb-1">
        <div class="card border-primary">
          <div class="card-body">
            <h6>Actions en attente</h6>
            <h3>{{ erp.kpis.pending_actions_total | number:'1.0-0' }}</h3>
            <small>Workflow vente ouvert (ERP)</small>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body pb-0" *ngIf="facturesGlobales || lc">
      <p class="gs-section-title mb-0">Synthèse vente</p>
    </div>
    <div class="card-body row gs-dashboard-kpis pt-1" *ngIf="facturesGlobales || lc">
      <div class="col-xl-3 col-md-6 col-sm-6 mb-1" *ngIf="facturesGlobales">
        <div class="card bg-light-success">
          <div class="card-body">
            <h6>Factures payées (TTC)</h6>
            <h3>{{ formatTnd(facturesGlobales.factures_payees.total_ttc || 0) }}</h3>
            <small>{{ facturesGlobales.factures_payees.nombre | number:'1.0-0' }} document(s)</small>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 col-sm-6 mb-1" *ngIf="facturesGlobales">
        <div class="card bg-light-danger">
          <div class="card-body">
            <h6>Factures à payer (TTC)</h6>
            <h3>{{ formatTnd(facturesGlobales.factures_a_payer.total_ttc || 0) }}</h3>
            <small>{{ facturesGlobales.factures_a_payer.nombre | number:'1.0-0' }} document(s)</small>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 col-sm-6 mb-1" *ngIf="lc?.ventesPeriode">
        <div class="card bg-light-primary">
          <div class="card-body">
            <h6>Ventes caisse (période)</h6>
            <h3>{{ formatTnd(lc.ventesPeriode.ca_ttc || 0) }}</h3>
            <small>{{ lc.ventesPeriode.nb_documents | number:'1.0-0' }} ticket(s) / vente(s) LC</small>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-md-6 col-sm-6 mb-1" *ngIf="lc?.tickets">
        <div class="card bg-light-warning">
          <div class="card-body">
            <h6>Tickets caisse</h6>
            <h3>{{ lc.tickets.actif | number:'1.0-0' }}</h3>
            <small>{{ lc.tickets.archive | number:'1.0-0' }} archivé(s)</small>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body row gs-dashboard-charts">
      <div class="col-lg-12 mb-2" *ngIf="erp">
        <div class="card gs-chart-card">
          <div class="card-header">
            <h5 class="mb-0">Activité documents vente</h5>
            <small class="text-muted">Créations journalières sur la période</small>
          </div>
          <div class="card-body gs-chart-wrap gs-chart-wrap--multi-legend">
            <canvas
              baseChart
              [data]="erpVenteChart.data"
              [options]="erpVenteChart.options"
              [type]="erpVenteChart.type"
            ></canvas>
          </div>
        </div>
      </div>

      <div class="col-lg-12 mb-2" *ngIf="facturesGlobales">
        <div class="card gs-chart-card">
          <div class="card-header">
            <h5 class="mb-0">Encours factures client</h5>
            <small class="text-muted">Montants TTC — station courante</small>
          </div>
          <div class="card-body gs-chart-wrap">
            <canvas
              baseChart
              [data]="facturesPaiementChart.data"
              [options]="facturesPaiementChart.options"
              [type]="facturesPaiementChart.type"
            ></canvas>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="card-body" *ngIf="!loading && stationId && !erp && !facturesGlobales">
    <div class="alert alert-info mb-0">
      Aucune statistique vente disponible. Vérifiez la station et l’API
      <code>/api/documents/vente/dashboard-stats</code> sur backend-erp.
    </div>
  </div>
</div>
